<template>
  <div class="app_container">
    <!--操作栏-->
    <div class="top_rect">
      <div style="display: flex; align-items: center;">
        <div class="name_style">{{ className }}</div>
        <span class="tip_style">（温馨提示：请尽量均匀分配学员至各期次）</span>
      </div>
      <div class="right">
        <div class="tip_style m-r-12">上次送审时间 {{ lastAuditTime }}</div>
        <butn v-if="Number(isEnrolling)" btntype="primary" title="提交送审" @click.native="sendAuditHandle"
          v-permission="'rotationEnroll:sendAudit'"></butn>
      </div>
    </div>
    <div class="remark_style" v-if="remark && remark.length > 0"> {{ remark }}</div>
    <!--轮训报名情况表-->
    <el-table :row-style="{ color: '#51627D', fontWeight: 400 }" :header-cell-style="{
      background: '#DCE7FA',
      color: '#343C4A',
      fontWeight: 500,
    }" :data="situationList" border :span-method="objectSpanMethod" style="width: 100%">
      <template>
        <el-table-column prop="periodName" label="报名期次" min-width="110%">
        </el-table-column>
        <el-table-column prop="courseTime" label="学员名单" min-width="240%">
          <span slot-scope="scope">
            <span v-for="(item, i) in scope.row.enrollList" :key="item.userId">{{ item.userName
              }}<span v-if="i < scope.row.enrollList.length - 1">、</span></span>
          </span>
        </el-table-column>
        <el-table-column prop="enrollNum" label="合计人数" :formatter="formatNum">
        </el-table-column>
        <el-table-column prop="enrollStatusName" label="审核状态">
          <template slot-scope="scope">
            <div class="enrollStatus_style" @click="showExaminDetail">
              {{ scope.row.enrollStatusName }}
            </div>
          </template>
        </el-table-column>
      </template>
    </el-table>

    <!--学员名单表-->
    <div class="top_rect m-t-24">
      <div class="title_style">
        学员名单
        <el-button type="primary" size="small" :disabled="selections.length === 0"
          @click="batchOperation">批量设置报名期次</el-button>
      </div>
      <!--<el-form class="right">
        <el-form-item class="m-l-14 m-r-12">
          <el-input
            prefix-icon="el-icon-search"
            size="small"
            v-model.trim="name"
            placeholder="姓名"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <butn btntype="primary" title="查询" @click="searchHandle"></butn>
          <butn title="重置" @click="resetData" class="czButn"></butn>
        </el-form-item>
      </el-form>-->
    </div>
    <el-table :data="paginatedEnrollList" @selection-change="selectionChange" border style="width: 100%">
      <el-table-column type="selection" width="40"> </el-table-column>
      <el-table-column prop="userName" label="姓名"> </el-table-column>
      <el-table-column prop="unitPosition" label="单位及职务">
      </el-table-column>
      <el-table-column label="报名期次" align="center">
        <template slot-scope="scope">
          <!-- 更新 scope.row.periodId 的值为它自身-->
          <el-select v-model="scope.row.periodId" placeholder="请选择" @change="changePeriod(scope.row)">
            <el-option v-for="item in periodList" :key="item.periodId" :label="item.periodName" :value="item.periodId"
              :disabled="item.periodId == '1'">
            </el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column prop="remarks" label="备注">
        <!-- <template slot-scope="scope" v-if="scope.row.periodId == '3'"> -->
        <template slot-scope="scope">
          <el-input v-model="scope.row.remarks" :placeholder="scope.row.periodId == '3'
            ? '请输入不参加原因(必填)'
            : ' 请输入报名备注(选填)'
            " maxlength="500" show-word-limit></el-input>
        </template>
      </el-table-column>
    </el-table>
    <div class="RCPagination">
      <butn btntype="primary" iconName="el-icon-arrow-left" title="返回" @click="dealBack" style="margin-left: 5px;"></butn>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.pageNum"
        :page-sizes="[10, 50, 100, 500, 1000]"
        :page-size="pagination.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="enrollList.length">
      </el-pagination>
    </div>
    <!-- 审核详情-->
    <ExaminDetailModal />
    <BatchOperationModal :showBatchModal="showBatchModal" :periodList="periodList" @ChangePeriodId="batchChangePeriodId"
      @closeBatchModal="closeBatchModal" />
  </div>
</template>
<script>
import vue from "@/main";
import butn from "@/components/button/index";
import ExaminDetailModal from "./examinDetailModal.vue";
import { Confirm } from "@/components/Confirm";
import {
  lastSendAuditTime,
  getEnrollSituation,
  getClassEnrollList,
  getPeriodList,
  rotationClassSendAudit,
} from "@/api/enrollment";
import BatchOperationModal from "./batchOperateModal.vue";

export default {
  components: {
    butn,
    ExaminDetailModal,
    BatchOperationModal,
  },
  data: function () {
    return {
      selections: [],
      name: "",
      classId: "",
      className: "",
      periodList: [],
      situationList: [],
      enrollList: [],
      lastAuditTime: "",
      isEnrolling: 0,
      showBatchModal: {
        flag: false
      },
      remark: '',
      pagination: {
        pageNum: 1,
        pageSize: 10
      }
    };
  },
  computed: {
    // 计算分页后的数据
    paginatedEnrollList() {
      const start = (this.pagination.pageNum - 1) * this.pagination.pageSize;
      const end = start + this.pagination.pageSize;
      return this.enrollList.slice(start, end);
    }
  },
  created() {
    //加载列表
    this.classId = this.$route.query.id;
    this.className = this.$route.query.className;
    this.isEnrolling = this.$route.query.isEnrolling;
    this.getLastSendAuditTime();
    this.getPeriodList();
    this.getEnrollSituation();
    this.getClassEnrollList();
  },
  methods: {
    // 分页方法
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.pagination.pageNum = 1; // 重置到第一页
    },
    handleCurrentChange(val) {
      this.pagination.pageNum = val;
    },
    // 查询轮训班期次
    getPeriodList() {
      getPeriodList(this.classId).then(({ code, data }) => {
        if (code !== 0) return;
        this.periodList = data;
        this.periodList.push({ periodId: "1", periodName: "未报名" });
      });
    },
    // 查询轮训班报名情况
    getEnrollSituation() {
      getEnrollSituation(this.classId).then(({ code, data }) => {
        if (code === 0) {
          let resp = data;
          let remark = null;
          for (let i = 0; i < resp.length; i++) {
            const item = resp[i]
            if (item.remark && item.remark.length > 0) {
              if (!remark) {
                remark = item.remark + '\n'
              } else {
                remark = remark  + item.remark + '\n';
              }
            }
            if (!item.enrollList) {
              item.enrollList = [];
            }
          }

          this.remark = remark;
          this.situationList = JSON.parse(JSON.stringify(resp)) || [];
        }
      });
    },
    // 查询轮训班学员名单
    getClassEnrollList() {
      getClassEnrollList({ classId: this.classId, name: this.name }).then(
        ({ code, data }) => {
          if (code === 0) {
            this.enrollList = data || [];
          }
        }
      );
    },
    // 查询上次送审时间
    getLastSendAuditTime() {
      lastSendAuditTime(this.classId).then(({ code, data }) => {
        if (code === 0) {
          this.lastAuditTime = data;
        }
      });
    },
    formatNum(row, column) {
      if (row.enrollList) {
        return row.enrollList.length;
      } else return 0;
    },
    // 送审提交
    sendAudit() {
      let classPeriodDtoList = [];
      classPeriodDtoList = this.enrollList.map((ele) => ({
        classEnrollId: ele.uuid,
        classParentId: this.classId,
        deptId: ele.deptId,
        periodId: ele.periodId,
        remarks: ele.remarks,
      }));
      rotationClassSendAudit(classPeriodDtoList).then(({ code, data }) => {
        if (code === 0) {
          this.$message({
            message: "送审成功",
            type: "success",
          });
          // 更新表格数据
          this.getLastSendAuditTime();
          this.getClassEnrollList();
          this.getEnrollSituation();
        }
      });
    },
    // 单个改变期次相关操作
    changePeriod(row) {
      // this.$set(this.enrollList, row.periodId, row.periodId);
      let curUser = [{ userName: row.userName, userId: row.userId }];
      this.handlePeriodIdMethod(row.periodId, curUser);
    },

    // 核心：统一处理修改期次
    handlePeriodIdMethod(periodId, curUser) {
      for (let i = 0; i < this.situationList.length; i++) {
        let enrollList = [];
        if (this.situationList[i].enrollList) {
          enrollList = this.situationList[i].enrollList;
        }
        // else {
        //   this.$set(this.situationList, this.situationList[i].enrollList, []);
        // }

        if (periodId == this.situationList[i].periodId) {
          // 并集
          let union = [...enrollList].filter((x) =>
            [...curUser].every((y) => y.userId !== x.userId)
          );
          union = union.concat(curUser);
          this.situationList[i].enrollList = union;
        }
        if (periodId !== this.situationList[i].periodId) {
          // 差集
          let diff = [...enrollList].filter((x) =>
            [...curUser].every((y) => y.userId !== x.userId)
          );
          this.situationList[i].enrollList = diff;
        }
      }
    },
    // 批量设置报名期次
    batchOperation() {
      this.showBatchModal = { flag: true };
    },
    closeBatchModal() {
      this.showBatchModal = { flag: false };
    },
    // 处理：批量设置期次
    batchChangePeriodId(periodId) {
      // 修改选中行的对应期次
      this.selections.forEach((item) => {
        item.periodId = periodId;
      });
      let curUser = this.selections.map((ele) => ({
        userName: ele.userName,
        userId: ele.userId,
      }));
      this.handlePeriodIdMethod(periodId, curUser);
    },
    //搜索学员
    searchHandle() {
      this.getClassEnrollList();
      // this.pagination.pageNum = 1;
    },
    resetData() {
      this.name = "";
      this.getClassEnrollList();
      // this.pagination.pageNum = 1;
    },
    // 合并列
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 3) {
        const dataProvider = this.situationList;
        const cellValue = row[column.property];
        if (cellValue) {
          // 上一条数据
          const prevRow = dataProvider[rowIndex - 1];
          // 下一条数据
          let nextRow = dataProvider[rowIndex + 1];
          // 当上一条数据等于下一条数据
          if (prevRow && prevRow[column.property] === cellValue) {
            return { rowspan: 0, colspan: 0 };
          } else {
            let rowspan = 1;
            while (nextRow && nextRow[column.property] === cellValue) {
              rowspan++;
              nextRow = dataProvider[rowspan + rowIndex];
            }
            if (rowspan > 1) {
              return { rowspan, colspan: 1 };
            }
          }
        }
      }
    },
    // 提交送审
    async sendAuditHandle() {
      // 先判断送审条件
      for (let i = 0; i < this.enrollList.length; i++) {
        if (this.enrollList[i].periodId == "1") {
          this.$message.error(
            "还有学员未选择报名期次，所有学员都报名后才能送审哦～"
          );
          return;
        }
        if (
          this.enrollList[i].periodId == "3" &&
          (this.enrollList[i].remarks == "" || !this.enrollList[i].remarks)
        ) {
          this.$message.error("请输入不参加原因");
          return;
        }
      }
      const text = "确定送审所有学员报名吗?";
      try {
        await Confirm(text, "系统提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        });
        this.sendAudit();
      } catch (error) {
        if (error === "cancel") return;
      }
    },
    showExaminDetail() {
      vue.$emit("ShowExaminDetail");
    },
    selectionChange: function (selections) {
      this.selections = selections;
    },
    dealBack() {
      // setItem(this.REFRESH_FLAG, true);
      this.$router.push({ path: "/enrollment" });
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.right .el-form-item {
  margin-bottom: 0;
}

.RCPagination {
  margin-bottom: 16px;
  display: flex;
  justify-content: space-between;
}

/* 自定义分页组件样式 - 灰色背景 */
::v-deep .el-pagination {
  .btn-prev,
  .btn-next,
  .el-pager li {
    background-color: #f5f7fa; /* 灰色背景 */
    border-radius: 2px;
    margin: 0 4px;
    justify-content: center;
  }

  .el-pager li:not(.disabled):not(.active):hover {
    color: #409EFF;
  }

  .el-pager li.active {
    background-color: #409EFF;
    color: white;
    border-color: #409EFF;
  }

}


.m-r-12 {
  margin-right: 12px;
}

.m-t-24 {
  margin-top: 32px;
}

.enrollStatus_style {
  color: #3a85ff;
  cursor: pointer;
}

.top_rect {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;

  .name_style {
    font-size: 20px;
    font-weight: bold;
    color: #000;
    line-height: 26px;
  }

  .title_style {
    font-size: 18px;
    font-weight: bold;
    
  }

  .tip_style {
    // margin-top: 4px;
    font-size: 14px;
    line-height: 26px;
    text-align: center;
  }

  .right {
    display: flex;
    align-items: center;
  }
}

.remark_style {
  color: red;
  font-size: 16px;
  white-space: pre-line;
  margin-bottom: 16px;
  line-height: 26px;
}
</style>
